// GENERATED from frontend/public/assets/farm/farm_scenery.json (scripts/farm_scenery.py).
// Re-run `python3 scripts/farm_scenery.py <src>` and paste the JSON here when the fence art
// changes — a constant, not a fetch, so the renderer never waits on a second request.
//
// Each entry is the origin (fractions of the sprite) of the point that was the segment's
// base-midpoint before it was sheared onto the cell edge (pickets stay upright, the rails
// take the 2:1 slope). Pin that origin to the edge's midpoint and the base lands exactly
// along the edge. Anything missing falls back to bottom-centre, right for the upright posts.
export const FENCE_ANCHORS = {
  farm_fence_se: [0.5, 0.8125],
  farm_fence_sw: [0.5, 0.8125],
  farm_gate: [0.5, 0.8125],
};

export const DEFAULT_ANCHOR = [0.5, 1];
export const anchorFor = (key) => FENCE_ANCHORS[key] ?? DEFAULT_ANCHOR;
